module.exports = __webpack_public_path__ + "img/btn_close.4b55a5c1.png";